<template>
  <section>
    <div class="modal-body">
      <form action="" class="m-form m-form--state">
        <div class="m-portlet__body">
          <div class="m-form__group form-group row">
            <div v-show="periodicity_type !== 3 && periodicity_type !== 2" class="col-lg-6">
              <label :class="{ 'has-danger': errors.has('days') }"> {{ 'access_days' | capitalize }} </label>
              <div class="m-checkbox-inline">
                <label v-show="day.name !== 'holidays'" v-for="day in days" :key="day.id" class="m-checkbox">
                  <a data-skin="dark" data-toggle="m-tooltip" data-placement="top" :title="getLongDay(day.name)">
                    {{ getShortDay(day.name) }}
                  </a>
                  <input type="checkbox" :checked="day.name != 'saturday' && day.name != 'sunday'" name="days" v-validate="periodicity_type !== 3 && periodicity_type !== 2 ?'required' : ''" :value="day.id" @click="setAccessDay(day, $event)" :disabled="view">
                  <span></span>
                </label>
              </div><br>
              <div class="m-checkbox-inline">
                <label class="m-checkbox">
                  {{ 'income_holidays' | capitalize }}
                  <input type="checkbox" name="holidays" :disabled="view" @click="setClickHoliday($event)">
                  <span></span>
                </label>
              </div>
              <span v-show="errors.has('days')" class="m-form__help m--font-danger"> {{errors.first('days')}} </span>
            </div>
            <div v-if="periodicity_type === 2" class="col-lg-3">
              <label for="start_day" :class="{ 'has-danger': errors.has('start_day') }"> {{ 'start_day' | capitalize }} </label>
              <s-date-time-picker v-model="start_day" @empty="start_day = $event" :options="config" :name="'start_day'" :id="'start_day'" :placeholder="currentDay" v-validate="'required'" :onlyDays="true"></s-date-time-picker>
              <span v-show="errors.has('start_day')" class="m-form__help m--font-danger"> {{errors.first('start_day')}} </span>
            </div>
            <div v-if="periodicity_type === 2" class="col-lg-3">
              <label for="end_day" :class="{ 'has-danger': errors.has('end_day') }"> {{ 'end_day' | capitalize }} </label>
              <s-date-time-picker v-model="end_day" @empty="end_day = $event" :options="config" :name="'end_day'" :id="'end_day'" :placeholder="currentDay" v-validate="'required'" :onlyDays="true"></s-date-time-picker>
              <span v-show="errors.has('end_day')" class="m-form__help m--font-danger"> {{errors.first('end_day')}} </span>
            </div>
            <div v-show="periodicity_type === 3" class="col-lg-6 custom-container">
              <div class="input-group m-input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" :class="{'has-danger': errors.has('each-days')}">
                    {{ 'each' | capitalize }}
                  </span>
                </div>
                <input v-model="each_days" type="text" class="form-control m-input" name="each-days" v-validate="periodicity_type === 3 ? 'required|numeric|min_value:1|max_value:30' : ''">
                <div class="input-group-prepend">
                  <span class="input-group-text" :class="{'has-danger': errors.has('each-days')}">
                    {{ $i18n.tc('day', each_days, {num: each_days}) | capitalize }}
                  </span>
                </div>
                <span v-show="errors.has('each-days')" class="m-form__help m--font-danger"> {{errors.first('each-days')}} </span>
              </div>
            </div>
            <div class="col-lg-6">
              <label for="periodicity" :class="{ 'has-danger': errors.has('periodicity') }"> {{ 'periodicity' | capitalize }} </label>
              <select name="periodicity" id="periodicity" v-model="periodicity_type" v-validate="'required'" class="form-control" @change="changePeriodicity(periodicity_type)" disabled>
                <option v-for="p in periodicity" :key="p.id" :value="p.id">
                  {{ p.name | capitalize }}
                </option>
              </select>
              <span v-show="errors.has('periodicity')" class="m-form__help m--font-danger"> {{errors.first('periodicity')}} </span>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer" v-show="!validate_footer">
      <button type="button" class="btn btn-secondary" @click="resetForm" id="btn-cancel">
        {{ 'close' | translate | capitalize }}
      </button>
      <button v-if="!view" type="button" class="btn btn-secondary" @click="clearForm" id="btn-cancel">
        {{ 'clear' | translate | capitalize }}
      </button>
      <button v-if="!view" type="button" class="btn btn-primary" @click="saveData">
        {{'save' | translate | capitalize }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: ['data', 'view', 'open_in_auth', 'array_in_auth', 'modal', 'edit_group', 'validate_footer'],
  data () {
    return {
      days: [],
      selected_days: [],
      days_tooltip: [],
      periodicity: [{ id: 1, name: 'weekly' }, { id: 2, name: 'monthly' }, { id: 3, name: 'custom' }],
      periodicity_type: 1,
      options: [{ id: 1, name: 'start_month' }, { id: 2, name: 'half_month' }, { id: 3, name: 'end_month' }],
      options_type: '',
      start_day: '',
      end_day: '',
      each_days: 1,
      ids: [],
      config: {
        format: 'dd',
        weekStart: 0,
        maxView: 2,
        keyboardNavigation: false,
        initialDate: '01'
      }
    }
  },
  created () {
    if (!this.modal) {
      this.$spinner.show()
    }
    this.retrieveDataAccessDay()
      .then((res) => {
        if (!this.modal) {
          this.$spinner.remove()
        }
        if (res.status === 200) {
          this.days = res.data.days
        }
      })
      .catch((err) => {
        if (!this.modal) {
          this.$spinner.remove()
        }
        this.$toast('error_load_data_form', 4)
        console.log(err)
      })
    this.validateCheckDays()
  },
  computed: {
    ...mapGetters({ clearFormData: 'getClearForm', editing: 'getEditAccessDay', loadData: 'getLoadDataAccessDay', access_day: 'getAccessDay' }),
    currentDay () {
      return moment().format('DD')
    },
    dataAccessDay () {
      const self = this
      let access_day = self.data.access_day
      return access_day
    }
  },
  methods: {
    ...mapActions(['getPermissionsProfileEntity']),
    changePeriodicity (periodicity_type) {
      if (periodicity_type === 3) {
        if (this.each_days.length > 4) {
          this.each_days = 1
        }
      }
    },
    resetForm () {
      this.setStatusLoadDataAccessDay(false)
      this.setModalAccessDay(false)
    },
    clearForm () {
      this.defaultValues()
      this.setStatusLoadDataAccessDay(false)
    },
    saveData () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            let val
            switch (this.periodicity_type) {
              case 1:
                val = this.selected_days
                break
              case 2:
                val = { start_day: this.start_day, end_day: this.end_day }
                break
              case 3:
                val = this.each_days
                break
              default:
                val = 0
                break
            }
            let access_day = { periodicity_type: this.periodicity_type, value: val, ids: this.ids }
            this.array_in_auth ? this.data.access_day = access_day : this.setDataAccessDay(access_day)
            this.setModalAccessDay(false)
            this.setStatusLoadDataAccessDay(false)
            this.scrollToNow()
          }
        })
    },
    defaultValues () {
      if (this.validate_footer) {
        this.selected_days = [this.days[0].id, this.days[1].id, this.days[2].id, this.days[3].id, this.days[4].id]
      } else {
        this.selected_days = []
      }
      this.periodicity = [{ id: 1, name: 'weekly' }, { id: 2, name: 'monthly' }, { id: 3, name: 'custom' }]
      this.periodicity_type = 1
      this.options = [{ id: 1, name: 'start_month' }, { id: 2, name: 'half_month' }, { id: 3, name: 'end_month' }]
      this.start_day = ''
      this.end_day = ''
      this.each_days = 1
      let checkboxes = document.getElementsByName('days')
      checkboxes.forEach(element => {
        element.checked = false
      })
      document.getElementsByName('holidays').forEach(element => {
        element.checked = false
      })
      setTimeout(() => {
        this.$validator.reset()
      }, 10)
      this.ids = []
      this.setDataAccessDay({})
    },
    setAccessDay (day, evt) {
      this.$validator.reset()
      if (evt.target.checked) {
        this.selected_days.push(day.id)
      } else {
        let idx = this.selected_days.indexOf(day.id)
        if (idx !== -1) {
          this.selected_days.splice(idx, 1)
        }
        if (this.editing) {
          let idxIds = this.ids.findIndex(array => array.day_id === day.id)
          if (idxIds !== -1) {
            this.ids.splice(idxIds, 1)
          }
        }
      }
    },
    setClickHoliday (evt) {
      let checkboxes = document.getElementsByName('days')
      checkboxes.forEach(element => {
        const day = this.days.find(day => day.id === element.value && day.name === 'holidays')
        if (evt.target.checked) {
          if (day) this.setAccessDay(day, evt)
        } else {
          if (day) this.setAccessDay(day, evt)
        }
      })
    },
    getShortDay (day) {
      let d = this.$options.filters.translate(day)
      setTimeout(() => {
        this.initTooltip(d)
      }, 200)
      return d.substring(0, 3)
    },
    initTooltip (day) {
      let $ = window.$
      let self = this
      $('[data-toggle="m-tooltip"]').each(function (key, element) {
        let idx = self.days_tooltip.indexOf(day)
        let el = $(this)
        if (idx === -1 && el[0].text.trim() === day.substring(0, 3)) {
          self.days_tooltip.push(day)
          let skin = el.data('skin') ? `m-tooltip--skin-${el.data('skin')}` : ''
          window.$(this).tooltip({
            trigger: 'hover',
            template: `<div class='m-tooltip ${skin} tooltip' role='tooltip'>
                          <div class='arrow'></div>
                          <div class='tooltip-inner'></div>
                      </div>`
          })
          $(el).attr('data-original-title', day)
        }
      })
    },
    getLongDay (day) {
      let d = this.$options.filters.translate(day)
      return d
    },
    checkall () {
      let checkboxes = document.getElementsByName('days')
      checkboxes.forEach(element => {
        element.checked = true
        this.selected_days.push(element.value)
      })
      document.getElementsByName('holidays').forEach(element => {
        element.checked = true
      })
    },
    validateCheckDays () {
      this.selected_days = []
      let checkboxes = document.getElementsByName('days')
      checkboxes.forEach(element => {
        if (element.checked) {
          this.selected_days.push(element.value)
        }
      })
    },
    scrollToNow (to) {
      window.scrollTo(0, parseInt(window.pageYOffset + 380))
    },
    ...mapActions(['retrieveDataAccessDay', 'setModalAccessDay', 'setDataAccessDay', 'setStatusClearForm', 'setStatusLoadDataAccessDay'])
  },
  watch: {
    clearFormData (newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        this.clearForm()
        this.setStatusClearForm(false)
      }
    },
    editing (newVal, oldVal) {
      this.defaultValues()
      if (newVal === true && oldVal === false && this.data.access_day) {
        // Se tiene cargado el objeto access_day
        if (this.data.access_day.length > 0 && this.data.access_day !== undefined) {
          this.data.forEach((access_day) => {
            this.periodicity_type = access_day.periodicity_type
            this.each_days = access_day.day === null ? 1 : access_day.day
            this.options_type = access_day.options_type === null ? '' : access_day.options_type
            if (access_day.periodicity_type === 1) {
              if (access_day.state === 1) {
                this.ids.push({id: access_day.id, day_id: access_day.day})
                this.selected_days.push(access_day.day)
              }
              let checkboxes = document.getElementsByName('days')
              checkboxes.forEach(element => {
                if (element.value === this.each_days && access_day.state === 1) {
                  element.checked = true
                  const day = this.days.find(day => day.id === element.value && day.name === 'holidays')
                  if (day) document.getElementsByName('holidays')[0].checked = true
                }
              })
            }
          })
        } else {
          // Se chequea todos los dias
          this.checkall()
          /* let checkboxes = document.getElementsByName('days')
          checkboxes.forEach(element => {
            element.checked = true
            this.selected_days.push(element.value)
          })
          document.getElementsByName('holidays').forEach(element => {
            element.checked = true
          }) */
        }
      } else {
        // Se cargo el arreglo de dias de acceso
        if (this.data.length > 0) {
          // Consulta de lunes a domingo
          let daysCheck = document.getElementsByName('days')
          daysCheck.forEach(element => {
            let buscarDia = this.data.find(dias => dias.day === element.value && dias.state === 1)
            if (buscarDia !== undefined) {
              element.checked = true
              this.selected_days.push(element.value)
            }
          })
          // Consulta de los festivos
          const day = this.days.find(day => day.name === 'holidays')
          if (day !== undefined) {
            let festivos = this.data.find(dias_festivos => dias_festivos.day === day.id && dias_festivos.state === 1)
            if (festivos !== undefined) {
              document.getElementsByName('holidays')[0].checked = true
            }
          }
        } else {
          // Se chequea todos los dias
          this.checkall()
        }
      }
    },
    loadData (newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        const load_access_day = this.array_in_auth ? this.data.access_day : this.access_day
        if (load_access_day) {
          this.periodicity_type = load_access_day.periodicity_type
          switch (this.periodicity_type) {
            case 1:
              document.getElementsByName('days').forEach(element => {
                element.checked = false
              })
              document.getElementsByName('holidays')[0].checked = false
              this.ids = load_access_day.value
              const length = this.ids.length
              for (let i = 0; i < length; i++) {
                let checkboxes = document.getElementsByName('days')
                checkboxes.forEach(element => {
                  if (element.value === load_access_day.value[i]) {
                    element.checked = true
                    // this.selected_days.push(load_access_day.value[i])
                    const day = this.days.find(day => day.id === element.value && day.name === 'holidays')
                    if (day) document.getElementsByName('holidays')[0].checked = true
                  }
                })
              }
              break
            case 2:
              this.start_day = load_access_day.value.start_day
              this.end_day = load_access_day.value.end_day
              break
            case 3:
              this.each_days = load_access_day.value
              break
            default:
              this.periodicity_type = 1
              break
          }
        } else {
          this.clearForm()
        }
      }
    },
    open_in_auth (newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        this.defaultValues()
      }
    },
    edit_group (newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        let checkboxes = document.getElementsByName('days')
        this.selected_days = []
        checkboxes.forEach(element => {
          element.checked = false
        })
        document.getElementsByName('holidays')[0].checked = false
        this.data.forEach((access_day) => {
          this.periodicity_type = access_day.periodicity_type
          this.each_days = access_day.day === null ? 1 : access_day.day
          this.options_type = access_day.options_type === null ? '' : access_day.options_type
          if (access_day.periodicity_type === 1) {
            if (access_day.state === 1) {
              this.ids.push(access_day.id)
            }
            let checkboxes = document.getElementsByName('days')
            checkboxes.forEach(element => {
              if (element.value === this.each_days && access_day.state === 1) {
                element.checked = true
                this.selected_days.push(this.each_days)
                const day = this.days.find(day => day.id === element.value && day.name === 'holidays')
                if (day) document.getElementsByName('holidays')[0].checked = true
              }
            })
          }
          // this.saveData()
        })
        this.$emit('setEditGroup', false)
      }
    }
  }
}
</script>

<style scoped>
  .custom-container {
    padding: 30px 15px !important;
  }

  .m-checkbox {
    margin-top: 0px !important;
  }

  .has-danger {
    color: #D73925 !important;
  }

  .m-checkbox {
    padding-bottom: 20px;
  }

</style>



// WEBPACK FOOTER //
// New.vue